import { defineStore } from 'pinia'
import { Permission, getLoginMark, clearLoginOriginMark, loginValidate } from '@/tool/permission'
import { getUserInfo, logout } from '@/tool/request'
import router from '@/router'
import { useUserStore } from './user'
import { useLayoutStore } from './layout'

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    isGenerate: false,
    isComplex: false,
    authInstance: null
  }),
  actions: {
    async getPermission() {
      await loginValidate()

      const { data: { user, permissions }} = await getUserInfo()

      this.isGenerate = true
      this.isComplex = user.isComplex === 1
      this.authInstance = new Permission(permissions)
      const str = this.authInstance['_value'].find(item=>item==='switch_employee')

      if(str) window.sessionStorage.setItem(str, str)

      const userStore = useUserStore()

      userStore.userName = user.nickname
      userStore.avatar = user.avatar
      userStore.userId = user.id
      userStore.deptName = user.deptName
      userStore.deptId = user.deptId
      userStore.sex = user.sex
      userStore.phone = user.username

      return this.authInstance
    },

    async logout(redirect) {
      const { accessToken } = getLoginMark()

      if (accessToken) await logout()
      await clearLoginOriginMark()
      if (!this.isGenerate) return
      this.isGenerate = false

      const { clearRoutes, clearApps } = useLayoutStore()

      clearRoutes()
      clearApps()

      if (redirect) redirect = encodeURIComponent(redirect)
      else if (router.currentRoute.value.query.redirect) redirect = router.currentRoute.value.query.redirect
      else redirect = encodeURIComponent(router.currentRoute.value.fullPath)

      router.push({ path: '/login', query: { redirect }})
    }
  }
})